/** @file sheetKindOf: whether a dropped file is an exploded sheet or a painted guide, and its facing. */

const SHEET = /^sheet[._-](\d+)\.png$/i;
const PAINTED = /^(?:painted|overpaint|guide)[._-](\d+)\.png$/i;

/**
 * `sheet.<deg>.png` is an exploded sheet, `painted.<deg>.png` (or `overpaint.` / `guide.`) a painted guide, each with
 * its facing in degrees (any folder in front is ignored); null for any other name (a slot PNG or zip).
 */
export function sheetKindOf(name: string): { kind: 'split' | 'overpaint'; facingDeg: number } | null {
  const base = name.replaceAll('\\', '/').split('/').pop() ?? name;
  const sheet = SHEET.exec(base);
  if (sheet !== null) return { kind: 'split', facingDeg: Number(sheet[1]) % 360 };
  const painted = PAINTED.exec(base);
  return painted === null ? null : { kind: 'overpaint', facingDeg: Number(painted[1]) % 360 };
}
